export default "__VITE_ASSET__9IV097fO__"